module.exports = __webpack_public_path__ + "img/fuell-success-animated-icon.c401cfea.gif";